import { render, staticRenderFns } from "./real-usage.vue?vue&type=template&id=1708756c&scoped=true&"
import script from "./real-usage.vue?vue&type=script&lang=js&"
export * from "./real-usage.vue?vue&type=script&lang=js&"
import style0 from "./real-usage.vue?vue&type=style&index=0&id=1708756c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1708756c",
  null
  
)

export default component.exports